import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import logo from "url:./logo-bg.webp";
import { NavLink } from "react-router-dom";
import { useState } from "react";

export const Menu = () => {
  const [expanded, setExpanded] = useState(false);

  return (
    <Navbar expanded={expanded} collapseOnSelect expand="md" bg="#fff">
      <Navbar.Brand href="/" className={({ isActive }) => (isActive ? "" : "")}>
        <img id="logo" src={logo} />
      </Navbar.Brand>

      <Navbar.Toggle
        className="menu-toggled"
        children={<div>Menu</div>}
        onClick={() => setExpanded(expanded ? false : "expanded")}
        label="Menu"
        aria-controls="responsive-navbar-nav"
      >
        <div className="menu-toggled-burger navbar-toggler-icon"></div>
        <div className="menu-toggled-label">Menu</div>
      </Navbar.Toggle>
      <Navbar.Collapse id="responsive-navbar-nav" className="justify-content-end">
        <Nav className="menu-link" eventkey="1">
          <NavLink to="/" className={({ isActive }) => (isActive ? "active" : "")} onClick={() => setExpanded(false)}>
            {" "}
            <div>Home</div>
          </NavLink>
        </Nav>
        <Nav className="menu-link" eventkey="1">
          <NavLink
            to="/about"
            className={({ isActive }) => (isActive ? "active" : "")}
            onClick={() => setExpanded(false)}
          >
            {" "}
            <div>About</div>
          </NavLink>
        </Nav>
        <Nav className="menu-link">
          <NavLink
            to="/faq"
            className={({ isActive }) => (isActive ? "active" : "")}
            onClick={() => setExpanded(false)}
          >
            {" "}
            <div>FAQ</div>
          </NavLink>
        </Nav>
        <Nav className="menu-link">
          <NavLink
            to="/contact"
            className={({ isActive }) => (isActive ? "active" : "")}
            onClick={() => setExpanded(false)}
          >
            Contact
          </NavLink>
        </Nav>
        {/* <Nav className="menu-link mr-auto">
          <Nav.Link className="donate-button">
            <Donate />
          </Nav.Link>
        </Nav> */}
      </Navbar.Collapse>
    </Navbar>
  );
};
